import { alpha } from "@mui/material"

const mixins = {
  navBuffer: {
    height: 392,
  },
  searchKeyboardBuffer: {
    height: 408,
  },
  searchCategoryFilterBuffer: {
    height: 86,
  },
  searchInputBuffer: {
    height: 92,
  },
  kioskSearchList: {
    height: 694,
  },
  kioskHeader: {
    height: 170,
  },
  bottomGredientPageEffect: {
    height: 492,
  },
  kioskDirectionCard: {
    height: 324,
  },
  kioskStepCard: {
    height: 324,
  },
  kioskStepOverviewCard: {
    height: 520,
  },
  kioskStepOverviewContent: {
    height: 456,
  },
  homeLayout: {
    height: 576,
  },
  pageLayout: {
    height: 1344,
  },
}
const createBottomGradientPageEffect = (sx = {}) => {
  return {
    content: "''",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    display: "inline-block",
    background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 35%)",
    height: mixins.bottomGredientPageEffect.height,
    pointerEvents: "none",
    zIndex: -1,
    ...sx,
  }
}

const BOTTOM_GREDIENT_PAGE_EFFECT = createBottomGradientPageEffect()

const BOTTOM_GREDIENT_SEARCH_PAGE_EFFECT = createBottomGradientPageEffect({
  background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 20%, #fff 20%)",
  height:
    mixins.searchKeyboardBuffer.height +
    mixins.searchCategoryFilterBuffer.height +
    mixins.searchInputBuffer.height,
})

const BOTTOM_GREDIENT_SEARCH_RESULT_LIST_EFFECT =
  createBottomGradientPageEffect({
    background:
      "linear-gradient(180deg,  rgba(246, 246, 246, 0.00) 15.9%, #F6F6F6 92.75%)",
    height: 348,
    zIndex: 0,
  })

const BOTTOM_GREDIENT_MAP_PAGE_EFFECT_1 = createBottomGradientPageEffect({
  background: "linear-gradient(180deg, rgba(255, 255, 255, 0) 20%, #fff 70%)",
  zIndex: 0,
})

const BOTTOM_GREDIENT_MAP_PAGE_EFFECT_2 = createBottomGradientPageEffect({
  background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 45%)",
  height: mixins.navBuffer.height + mixins.searchCategoryFilterBuffer.height,
  zIndex: -1,
})

const BOTTOM_GREDIENT_SUGGESTED_BRAND_SECTION_EFFECT =
  createBottomGradientPageEffect({
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(218, 205, 170, 0.60) 100%)",
    height: "100%",
    // Ensure the gradient effect reaches the left and right edges by accounting for page padding.
    left: "-60px",
    right: "-60px",
    zIndex: -1,
  })

export const themeOptionFactory = (theme) => ({
  mixins,
  assets: {
    backIcon: {
      icon_comp: "ArrowLeftIcon",
    },
    fonts: {
      urls: ["/assets/fonts/one-siam/sukhumvit-set.css"],
    },
    startIcon: {
      icon_path:
        "M17.89,10.58a2.2,2.2,0,0,0-3-1.12,2.22,2.22,0,0,0-1.4-1.26A4.83,4.83,0,1,0,7.65,9.31v4.26c-.27-.33-.49-.58-.67-.76a3,3,0,0,0-2-1,2.84,2.84,0,0,0-2.45,1.05.69.69,0,0,0,.06.87c.12.19.6,1.1,2.5,5.44a8.81,8.81,0,0,0,1.55,2.3,2.86,2.86,0,0,1,1,2,.7.7,0,0,0,.71.7H19.23a.7.7,0,0,0,.71-.7c0-1.66,1.12-2.54,1.12-4.92v-6A2.21,2.21,0,0,0,17.89,10.58Zm1.76,8c0,1.85-.85,2.6-1.07,4.22H9c-.35-1.69-1.82-2.31-2.61-4.13-.54-1.22-1.76-4-2.36-5.19a2.12,2.12,0,0,1,1-.2,1.67,1.67,0,0,1,1,.55c.34.34.9,1,1.82,2.19a.7.7,0,0,0,1.25-.44V6H7.65V7.63A3.38,3.38,0,0,1,6.44,5a3.42,3.42,0,0,1,6.84,0,3.32,3.32,0,0,1-.6,1.93,3.13,3.13,0,0,1-.62.69V5.06a2.21,2.21,0,0,0-4.41,0V6H9.06v-1a.8.8,0,0,1,.8-.8.79.79,0,0,1,.79.8v8.25a.7.7,0,0,0,.71.7.7.7,0,0,0,.7-.7v-3a.78.78,0,0,1,.62-.77l.18,0a.79.79,0,0,1,.79.8v3a.7.7,0,0,0,.71.7.7.7,0,0,0,.7-.7V11.43a.79.79,0,0,1,.8-.79.79.79,0,0,1,.79.79v1.88a.7.7,0,0,0,.71.7.7.7,0,0,0,.7-.7v-.75a.8.8,0,0,1,.8-.8.79.79,0,0,1,.79.8Z",
    },
    empty: {
      promotions: {
        icon_path:
          "M22.1797 5.21149H16.7162C17.0357 4.86138 17.2497 4.42811 17.3336 3.96163C17.4175 3.49516 17.3678 3.01447 17.1904 2.57499C17.0129 2.1355 16.7149 1.75511 16.3306 1.47767C15.9464 1.20023 15.4915 1.03703 15.0185 1.00689C14.6875 0.982106 14.3549 1.02434 14.0407 1.13106C13.7264 1.23778 13.4369 1.40679 13.1894 1.62799C12.4204 2.66519 12.0018 3.92035 11.9942 5.21149H11.6442C11.6367 3.92036 11.2182 2.66518 10.4492 1.62799C10.0741 1.29876 9.60977 1.08816 9.11496 1.02283C8.62015 0.957497 8.11708 1.04037 7.66937 1.26096C7.22166 1.48155 6.84943 1.82995 6.59973 2.2621C6.35004 2.69425 6.23411 3.19075 6.2666 3.68879C6.30572 4.25624 6.53739 4.79333 6.9233 5.21119H1.4687C1.34439 5.21124 1.22519 5.26066 1.1373 5.34856C1.04941 5.43647 1.00003 5.55568 1 5.67999V9.11879C1.00003 9.24309 1.04942 9.36229 1.13731 9.45018C1.2252 9.53807 1.3444 9.58746 1.4687 9.58749H2.0742V20.8922C2.07478 21.3582 2.26017 21.805 2.58969 22.1345C2.91922 22.464 3.36598 22.6494 3.832 22.65H19.8164C20.2825 22.6496 20.7294 22.4643 21.0589 22.1347C21.3885 21.8052 21.5738 21.3583 21.5742 20.8922V9.58699H22.1797C22.304 9.58696 22.4232 9.53757 22.5111 9.44968C22.599 9.36179 22.6484 9.24259 22.6484 9.11829V5.68029C22.6484 5.55598 22.599 5.43677 22.5111 5.34886C22.4232 5.26096 22.304 5.21154 22.1797 5.21149ZM13.8086 2.33259C14.1248 2.05508 14.5382 1.91454 14.958 1.94188C15.3778 1.96923 15.7696 2.16221 16.0471 2.47839C16.3246 2.79457 16.4652 3.20804 16.4378 3.62784C16.4105 4.04764 16.2175 4.43938 15.9013 4.71689C15.2905 5.05526 14.6009 5.2259 13.9028 5.21149H12.9312C12.9562 4.18988 13.2595 3.19447 13.8086 2.33259ZM7.7386 4.71689C7.42593 4.4385 7.23603 4.04776 7.2103 3.62991C7.18457 3.21205 7.32512 2.80097 7.60127 2.48633C7.87743 2.17168 8.2668 1.97899 8.68446 1.95029C9.10212 1.92158 9.51419 2.05919 9.8308 2.33309C10.3796 3.19488 10.6828 4.1901 10.7077 5.21149H9.746C9.04495 5.22716 8.35211 5.05648 7.7386 4.71689ZM20.6367 20.8922C20.6363 21.1095 20.5498 21.3179 20.3961 21.4716C20.2424 21.6253 20.0341 21.7118 19.8167 21.7122H3.832C3.61464 21.7118 3.4063 21.6253 3.25261 21.4716C3.09892 21.3179 3.0124 21.1095 3.012 20.8922V9.58699H20.637L20.6367 20.8922ZM21.7109 8.64949H1.9375V6.14879H9.543C9.7652 6.16789 9.9846 6.18059 10.1904 6.18059C10.3757 6.18034 10.5609 6.16972 10.7451 6.14879H12.8932C13.0771 6.16972 13.2621 6.18033 13.4472 6.18059C13.6531 6.18059 13.8727 6.16789 14.095 6.14879H21.7109V8.64949Z M15.455 19.3424C15.1472 19.3422 14.8449 19.2604 14.579 19.1051C14.3792 18.9897 14.204 18.836 14.0635 18.6529C13.923 18.4698 13.82 18.2608 13.7602 18.0378C13.7005 17.8149 13.6853 17.5824 13.7154 17.3535C13.7456 17.1247 13.8205 16.9041 13.9359 16.7042C14.0513 16.5043 14.205 16.3291 14.3881 16.1887C14.5712 16.0482 14.7802 15.9451 15.0032 15.8854C15.2261 15.8257 15.4587 15.8105 15.6875 15.8406C15.9163 15.8708 16.137 15.9457 16.3368 16.0611C16.6379 16.235 16.8808 16.4942 17.0346 16.806C17.1883 17.1179 17.2462 17.4683 17.2009 17.813C17.1555 18.1578 17.0089 18.4813 16.7797 18.7427C16.5505 19.0042 16.2489 19.1918 15.913 19.2818C15.7636 19.3216 15.6097 19.342 15.455 19.3424ZM15.4589 16.7633C15.2784 16.7631 15.1028 16.8225 14.9595 16.9323C14.8161 17.0421 14.713 17.1961 14.6662 17.3705C14.6193 17.5449 14.6313 17.7299 14.7003 17.8967C14.7693 18.0636 14.8915 18.203 15.0478 18.2933C15.1408 18.3478 15.2437 18.3832 15.3505 18.3972C15.4574 18.4113 15.5659 18.4039 15.6698 18.3753C15.8267 18.3336 15.9677 18.2463 16.0748 18.1245C16.182 18.0026 16.2506 17.8516 16.2718 17.6907C16.293 17.5298 16.266 17.3662 16.1941 17.2207C16.1223 17.0751 16.0088 16.9542 15.8681 16.8733C15.7439 16.801 15.6027 16.763 15.4589 16.7633ZM10.3783 19.1139C10.2961 19.1139 10.2152 19.0923 10.144 19.0511C10.0727 19.01 10.0136 18.9508 9.9725 18.8795C9.93141 18.8082 9.90982 18.7273 9.90991 18.6451C9.91001 18.5628 9.93178 18.482 9.97303 18.4108L13.432 12.4195C13.4628 12.3662 13.5038 12.3195 13.5526 12.282C13.6015 12.2445 13.6572 12.217 13.7167 12.2011C13.7762 12.1851 13.8382 12.1811 13.8992 12.1891C13.9603 12.1971 14.0191 12.2171 14.0724 12.2479C14.1257 12.2787 14.1725 12.3197 14.21 12.3685C14.2474 12.4174 14.2749 12.4731 14.2909 12.5326C14.3068 12.592 14.3109 12.6541 14.3028 12.7151C14.2948 12.7761 14.2748 12.835 14.244 12.8883L10.7846 18.8795C10.7435 18.9509 10.6843 19.0101 10.613 19.0513C10.5416 19.0925 10.4607 19.1141 10.3783 19.1139ZM8.75623 15.4752C8.4866 15.4749 8.22067 15.4125 7.97897 15.293C7.73728 15.1735 7.52631 15 7.36237 14.786C7.19843 14.5719 7.08592 14.323 7.03352 14.0585C6.98113 13.794 6.99025 13.521 7.0602 13.2606C7.13015 13.0002 7.25904 12.7594 7.43692 12.5568C7.61479 12.3542 7.83688 12.1951 8.08602 12.092C8.33515 11.9889 8.60466 11.9445 8.87371 11.9622C9.14275 11.9799 9.40413 12.0592 9.63763 12.194C9.9388 12.3678 10.1817 12.627 10.3355 12.9388C10.4894 13.2506 10.5473 13.601 10.502 13.9458C10.4567 14.2905 10.3102 14.6141 10.081 14.8756C9.85177 15.137 9.55017 15.3246 9.21433 15.4147C9.06488 15.4545 8.9109 15.4749 8.75623 15.4752ZM8.76023 12.8952C8.68818 12.8954 8.61646 12.905 8.54683 12.9235C8.39028 12.9657 8.24975 13.0534 8.14294 13.1754C8.03614 13.2974 7.96786 13.4483 7.9467 13.609C7.92554 13.7698 7.95246 13.9332 8.02406 14.0787C8.09567 14.2242 8.20874 14.3452 8.34903 14.4265C8.44191 14.4815 8.54495 14.5171 8.65195 14.5311C8.75895 14.5452 8.86769 14.5375 8.97163 14.5085C9.12823 14.4665 9.26887 14.3791 9.37578 14.2572C9.4827 14.1353 9.55108 13.9845 9.57229 13.8237C9.5935 13.663 9.56659 13.4996 9.49496 13.3542C9.42332 13.2087 9.31018 13.0878 9.16983 13.0066C9.04567 12.934 8.90404 12.8957 8.76023 12.8952Z",
      },
      events: {
        icon_path:
          "M3 2.98103H21.6286V18.8988C21.6286 21.1637 19.7925 22.9999 17.5275 22.9999H3V2.98103ZM4.25118 4.23221V21.7487H17.5275C19.1015 21.7487 20.3774 20.4727 20.3774 18.8988V4.23221H4.25118Z M12.3142 9.99179L13.6902 12.3998L16.4057 12.9644L14.5406 15.0173L14.8428 17.7741L12.3142 16.6347L9.78552 17.7741L10.0877 15.0172L8.22273 12.9644L10.9381 12.3998L12.3142 9.99179ZM12.3142 12.5136L11.7448 13.51L10.6211 13.7436L11.3929 14.5932L11.2678 15.7338L12.3142 15.2623L13.3605 15.7338L13.2355 14.5932L14.0073 13.7436L12.8836 13.51L12.3142 12.5136Z M6.47532 3.60662V1H7.7265V3.60662H6.47532Z M11.6887 3.60662V1H12.9399V3.60662H11.6887Z M16.9019 3.60662V1H18.1531V3.60662H16.9019Z M3.62559 6.45652H21.003V7.70769H3.62559V6.45652Z M21.6285 17.1612C21.6285 18.4663 20.5703 19.5245 19.2651 19.5245H18.153V20.6367C18.153 21.9418 17.0948 23 15.7897 23V21.7488C16.4038 21.7488 16.9018 21.2508 16.9018 20.6367V18.2733H19.2651C19.8793 18.2733 20.3773 17.7753 20.3773 17.1612H21.6285Z",
      },
    },
    navigation: {
      origin: {
        icon_path:
          "M11.8012 12.0004C12.3878 12.0004 12.8901 11.7868 13.3079 11.3595C13.7256 10.9322 13.9345 10.4186 13.9345 9.81858C13.9345 9.21858 13.7256 8.70495 13.3079 8.27766C12.8901 7.8504 12.3878 7.63677 11.8012 7.63677C11.2145 7.63677 10.7123 7.8504 10.2945 8.27766C9.87673 8.70495 9.66785 9.21858 9.66785 9.81858C9.66785 10.4186 9.87673 10.9322 10.2945 11.3595C10.7123 11.7868 11.2145 12.0004 11.8012 12.0004ZM11.8012 20.0186C13.9701 17.9822 15.579 16.1322 16.6278 14.4686C17.6767 12.805 18.2012 11.3277 18.2012 10.0368C18.2012 8.05494 17.5834 6.43221 16.3478 5.16858C15.1123 3.90495 13.5967 3.27312 11.8012 3.27312C10.0056 3.27312 8.49006 3.90495 7.25451 5.16858C6.01896 6.43221 5.40117 8.05494 5.40117 10.0368C5.40117 11.3277 5.92562 12.805 6.97452 14.4686C8.02339 16.1322 9.6323 17.9822 11.8012 20.0186ZM11.8012 22.9095C8.93894 20.4186 6.80116 18.1049 5.38784 15.9686C3.97451 13.8322 3.26784 11.8549 3.26784 10.0368C3.26784 7.3095 4.12562 5.13675 5.84117 3.51858C7.55673 1.9004 9.54339 1.09131 11.8012 1.09131C14.059 1.09131 16.0456 1.9004 17.7612 3.51858C19.4767 5.13675 20.3345 7.3095 20.3345 10.0368C20.3345 11.8549 19.6278 13.8322 18.2145 15.9686C16.8012 18.1049 14.6634 20.4186 11.8012 22.9095Z",
      },
      destination: {
        icon_path:
          "M11.8012 12.0004C12.3878 12.0004 12.8901 11.7868 13.3079 11.3595C13.7256 10.9322 13.9345 10.4186 13.9345 9.81858C13.9345 9.21858 13.7256 8.70495 13.3079 8.27766C12.8901 7.8504 12.3878 7.63677 11.8012 7.63677C11.2145 7.63677 10.7123 7.8504 10.2945 8.27766C9.87673 8.70495 9.66785 9.21858 9.66785 9.81858C9.66785 10.4186 9.87673 10.9322 10.2945 11.3595C10.7123 11.7868 11.2145 12.0004 11.8012 12.0004ZM11.8012 20.0186C13.9701 17.9822 15.579 16.1322 16.6278 14.4686C17.6767 12.805 18.2012 11.3277 18.2012 10.0368C18.2012 8.05494 17.5834 6.43221 16.3478 5.16858C15.1123 3.90495 13.5967 3.27312 11.8012 3.27312C10.0056 3.27312 8.49006 3.90495 7.25451 5.16858C6.01896 6.43221 5.40117 8.05494 5.40117 10.0368C5.40117 11.3277 5.92562 12.805 6.97452 14.4686C8.02339 16.1322 9.6323 17.9822 11.8012 20.0186ZM11.8012 22.9095C8.93894 20.4186 6.80116 18.1049 5.38784 15.9686C3.97451 13.8322 3.26784 11.8549 3.26784 10.0368C3.26784 7.3095 4.12562 5.13675 5.84117 3.51858C7.55673 1.9004 9.54339 1.09131 11.8012 1.09131C14.059 1.09131 16.0456 1.9004 17.7612 3.51858C19.4767 5.13675 20.3345 7.3095 20.3345 10.0368C20.3345 11.8549 19.6278 13.8322 18.2145 15.9686C16.8012 18.1049 14.6634 20.4186 11.8012 22.9095Z",
      },
      start: {
        icon_path:
          "M19.7904 3.61714L14.148 18.4323L12.1277 11.2798L4.97529 9.25951L19.7904 3.61714ZM22.0438 2.95833C22.4235 1.96136 21.4464 0.984051 20.4494 1.36369L2.51416 8.19435C1.40181 8.61799 1.47275 10.2148 2.61805 10.5383L10.6115 12.796L12.8693 20.7894C13.1927 21.9339 14.7894 22.0064 15.2132 20.8934L22.0438 2.95833Z",
      },
      step: {
        icon_path:
          "M6.96484 2.83105C6.96484 2.41684 7.30063 2.08105 7.71484 2.08105H19.3115C19.7257 2.08105 20.0615 2.41684 20.0615 2.83105C20.0615 3.24526 19.7257 3.58105 19.3115 3.58105H7.71484C7.30063 3.58105 6.96484 3.24526 6.96484 2.83105Z M6.96484 9.5449C6.96484 9.13069 7.30063 8.7949 7.71484 8.7949H19.3115C19.7257 8.7949 20.0615 9.13069 20.0615 9.5449C20.0615 9.95911 19.7257 10.2949 19.3115 10.2949H7.71484C7.30063 10.2949 6.96484 9.95911 6.96484 9.5449Z M6.96484 16.2588C6.96484 15.8446 7.30063 15.5088 7.71484 15.5088H19.3115C19.7257 15.5088 20.0615 15.8446 20.0615 16.2588C20.0615 16.673 19.7257 17.0088 19.3115 17.0088H7.71484C7.30063 17.0088 6.96484 16.673 6.96484 16.2588Z M0.25 2.83111C0.25 1.40563 1.40555 0.25 2.83106 0.25C4.25656 0.25 5.41211 1.40563 5.41211 2.83111C5.41211 4.25659 4.25656 5.41222 2.83106 5.41222C1.40555 5.41222 0.25 4.25659 0.25 2.83111ZM2.83106 1.75C2.23402 1.75 1.75 2.23401 1.75 2.83111C1.75 3.42821 2.23402 3.91222 2.83106 3.91222C3.42808 3.91222 3.91211 3.42821 3.91211 2.83111C3.91211 2.23401 3.42808 1.75 2.83106 1.75Z M0.25 9.545C0.25 8.11952 1.40555 6.96387 2.83106 6.96387C4.25657 6.96387 5.41211 8.11952 5.41211 9.545C5.41211 10.9705 4.25655 12.1261 2.83106 12.1261C1.40556 12.1261 0.25 10.9705 0.25 9.545ZM2.83106 8.46387C2.23403 8.46387 1.75 8.94788 1.75 9.545C1.75 10.1421 2.23402 10.6261 2.83106 10.6261C3.42809 10.6261 3.91211 10.1421 3.91211 9.545C3.91211 8.94788 3.42807 8.46387 2.83106 8.46387Z M0.25 16.2588C0.25 14.8334 1.40554 13.6777 2.83106 13.6777C4.25658 13.6777 5.41211 14.8334 5.41211 16.2588C5.41211 17.6842 4.2566 18.84 2.83106 18.84C1.40551 18.84 0.25 17.6842 0.25 16.2588ZM2.83106 15.1777C2.23404 15.1777 1.75 15.6618 1.75 16.2588C1.75 16.856 2.23407 17.34 2.83106 17.34C3.42804 17.34 3.91211 16.856 3.91211 16.2588C3.91211 15.6618 3.42806 15.1777 2.83106 15.1777Z",
      },
    },
    venueFilter: {
      all: {
        mime: "image/svg",
        url: "https://s3.venue.in.th/One_siam_logo_d56dd61fec.svg",
        width: 52,
        height: 32,
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "transparent !important",
        },
        html: {
          "&.home-screen": {
            "& .app-layout": {
              height: `${mixins.homeLayout.height}px !important`,
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,

              "& .app-header": {
                display: "none",
              },
            },
            "& .MuiBackdrop-root": {
              height: `${mixins.homeLayout.height}px !important`,
              marginTop: "auto",
              bottom: 0,
            },
            "& .loading-screen": {
              height: `${mixins.homeLayout.height}px !important`,
              marginTop: "auto",
              bottom: 0,
            },
          },
        },
        ".MuiBackdrop-root": {
          height: `${mixins.pageLayout.height}px !important`,
        },
        ".loading-screen": {
          height: `${mixins.pageLayout.height}px !important`,
        },
        ".app-layout": {
          height: `${mixins.pageLayout.height}px !important`,
          backgroundColor: theme.palette.background.default,
          overflow: "hidden",
        },
      },
    },
    LoadingScreen: {
      styleOverrides: {
        root: {},
      },
    },
    MapUpdateLoadingScreen: {
      styleOverrides: {
        root: {},
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
        outlinedPrimary: {},
        containedPrimary: {},
        startIcon: {},
      },
    },
    AppLayout: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
        },
        headerWrapper: {
          "@media (min-height: 578px)": {
            display: "block",
          },
          display: "none",
          height: mixins.kioskHeader.height,
        },
        footerWrapper: {
          height: 0,
        },
        contentWrapper: {},
      },
    },
    AppHeader: {
      styleOverrides: {
        toolbar: {
          flexDirection: "row-reverse",
          height: mixins.kioskHeader.height,
        },
        titleContainer: {
          display: "block",
        },
      },
    },
    AppMap: {
      styleOverrides: {
        indoorMapContainer: {
          backgroundColor: theme.palette.common.white,
        },
        ordinalSelectMenu: {
          zIndex: theme.zIndex.appBar + 1,
          bottom: `calc(${mixins.navBuffer.height}px + 182px)`,
        },
        mainMenuContainer: {},
        footerActionContainer: {},
        navigationWrapper: {
          padding: 0,
          ":after": BOTTOM_GREDIENT_MAP_PAGE_EFFECT_2,
          "& .MuiBottomNavigation-root": {
            boxShadow: "none",
          },
        },
        toolbarContainer: {
          bottom: 0,
          zIndex: 1,
        },
        searchBarContainer: {
          height: "auto",
          padding: theme.spacing(0, 6),
        },
        actionContainer: {
          display: "none",
        },
      },
    },
    AppPageLayout: {
      styleOverrides: {
        root: {},
        navBuffer: {
          height: mixins.navBuffer.height,
        },
        contentWrapper: {
          [theme.breakpoints.up("md")]: {
            maxWidth: "unset",
            padding: theme.spacing(3, 6),
          },
        },
      },
    },
    DiningCard: {
      styleOverrides: {
        root: {
          display: "flex",
          height: "265px",
          borderRadius: "4px",
          backgroundColor: theme.palette.background.paper,
          flexDirection: "column",
          boxShadow: "none",
        },
        headerContainer: {
          display: "flex",
          alignItems: "flex-start",
          gap: theme.spacing(2),
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 56px",
          backgroundColor: theme.palette.grey[500],
          borderRadius: "0",
          width: "56px",
          height: "56px",
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        occupantLogoFallback: {
          color: theme.palette.grey[500],
          width: "25px",
          height: "25px",
          "&.MuiSvgIcon-root": {
            width: "40px",
            height: "40px",
          },
        },
        featuredImageFallback: {
          width: "50px",
          height: "50px",
        },
        occupantFeaturedImage: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 90px",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "128px",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(2),
          height: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.15,
          },
        },
        levelContainer: {
          display: "inline-flex",
          "& .MuiTypography-root": {
            lineHeight: 1,
            fontWeight: 400,
            paddingLeft: "4px",
            fontSize: "1.25rem",
            borderLeft: `4px solid ${theme.palette.primary.main}`,
          },
        },
        divider: {
          display: "none",
        },
        venueLogo: {
          objectFit: "contain",
          height: "26px",
          width: "86px",
          filter: "brightness(0) invert(0.8)",
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
          fontSize: "1.25rem",
          lineHeight: 1.5,
        },
        titleContainer: {},
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
      },
    },
    DiningSkeletonCard: {
      styleOverrides: {
        root: {
          display: "flex",
          height: "265px",
          borderRadius: "4px",
          backgroundColor: theme.palette.background.paper,
          flexDirection: "column",
          boxShadow: "none",
        },
        avatar: {
          boxShadow: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "0",
          width: "100%",
          height: "128px",
          flex: "0 0 128px",
        },
        logo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 56px",
          borderRadius: "0",
          width: "56px",
          height: "56px",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(2),
          height: "100%",
        },
        headerContainer: {
          display: "flex",
          alignItems: "flex-start",
          gap: theme.spacing(2),
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
        venueLogo: {
          height: "26px",
          width: "86px",
        },
        primaryText: {
          fontSize: "1.25rem",
        },
        secondaryText: {
          fontSize: "1.25rem",
        },
      },
    },
    DirectoryOccupantCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "311px",
          borderRadius: "4px",
          backgroundColor: theme.palette.background.paper,
          boxShadow: "none",
          "&.is-highlight": {
            gridColumn: "span 2",
            width: "100%",
          },
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 90px",
          boxShadow: "none",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "178px",
            "& .MuiSvgIcon-root": {
              width: "56px",
              height: "56px",
            },
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(2),
          height: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.15,
          },
        },
        levelContainer: {
          display: "inline-flex",
          "& .MuiTypography-root": {
            lineHeight: 1,
            fontWeight: 400,
            paddingLeft: "4px",
            fontSize: "1.25rem",
          },
          "&.siam-center .MuiTypography-root": {
            borderLeft: `4px solid #ECCB20`,
          },
          "&.siam-discovery .MuiTypography-root": {
            borderLeft: `4px solid #66676C`,
          },
          "&.siam-paragon .MuiTypography-root": {
            borderLeft: `4px solid #A3873E`,
          },
        },
        divider: {
          display: "none",
        },
        venueLogo: {
          objectFit: "contain",
          height: "26px",
          width: "86px",
          filter: "brightness(0) invert(0.8)",
        },
        titleText: {
          fontSize: "1.25rem",
        },
        titleContainer: {},
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
      },
    },
    AdSuggestCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "268px",
          borderRadius: "4px",
          backgroundColor: theme.palette.background.paper,
          boxShadow: "none",
          "&.is-highlight": {
            gridColumn: "span 2",
            width: "100%",
          },
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 90px",
          boxShadow: "none",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "178px",
            "& .MuiSvgIcon-root": {
              width: "56px",
              height: "56px",
            },
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(2),
          height: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.15,
          },
        },
        titleText: {
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          fontSize: "1.25rem",
        },
        titleContainer: {},
      },
    },
    AppDining: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          margin: theme.spacing(0, -3),
          height: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          ":after": BOTTOM_GREDIENT_PAGE_EFFECT,
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.5),
          "& .all": {
            display: "none",
          },
        },
        toolbarContainer: {
          position: "relative",
          display: "flex",
          margin: theme.spacing(3, 6, 0),
          gap: theme.spacing(3),
        },
        searchBarContainer: {
          flex: "1 1 0",
          width: "auto",
          height: "auto",
          padding: theme.spacing(0),
        },
        filterSection: {
          position: "relative",
          display: "none",
          flexDirection: "column",
          gap: theme.spacing(2),
          top: 0,
          zIndex: 1,
          paddingTop: theme.spacing(4),
          width: "100vw",
          "& .subCategory-filterbar": {
            padding: theme.spacing(0),
            position: "relative",
            maxWidth: "100%",
            margin: "0 auto",
            "&:after": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
              zIndex: 1,
              position: "absolute",
              right: "2px",
              top: 0,
              bottom: 0,
            },
            "&:before": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
              zIndex: 1,
              position: "absolute",
              left: "-10px",
              top: 0,
              bottom: 0,
            },
          },
        },
        filterContainer: {
          padding: 0,
        },
        categoryFilterBar: {
          gap: theme.spacing(2),
          padding: theme.spacing(0.25, 0),
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(6),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
          "& .allFilter-button": {
            textTransform: "uppercase",
          },
        },
        diningImageCard: {
          display: "block",
          width: "230px",
          height: "200px",
          "& .MuiCardActionArea-root, & .MuiCardMedia-root": {
            height: "100%",
            width: "100%",
          },
          "& .MuiCardHeader-root": {
            paddingBottom: theme.spacing(1),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "50px",
            height: "50px",
          },
        },
        diningAvatar: {},
        diningAvatarFallBack: {},
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateRows: "repeat(2, max-content)",
          gridTemplateColumns: "repeat(4, max-content)",
          gap: theme.spacing(2.5),
          padding: theme.spacing(0.75, 3.75),
          overflowX: "hidden",
          overflowY: "auto",
          minHeight: "730px",
          height: "730px",
          width: "100%",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
        gridItem: {
          width: "228px",
        },
        emptyDataContainer: {
          minHeight: "554px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
        },
        navigationWrapper: {
          zIndex: theme.zIndex.appBar,
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: 0,
        },
        mainMenuContainer: {},
        footerActionContainer: {},
      },
    },
    ServicePage: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          margin: theme.spacing(0, -3),
          height: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          ":after": BOTTOM_GREDIENT_PAGE_EFFECT,
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateRows: "repeat(2, max-content)",
          gridTemplateColumns: "repeat(2, max-content)",
          gap: theme.spacing(3),
          overflowX: "hidden",
          overflowY: "auto",
          minHeight: "874px",
          height: "874px",
          width: "100%",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          justifyContent: "center",
        },
        gridItem: {
          width: "480px",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
        },
        emptyDataContainer: {
          minHeight: "874px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
        },
        navigationWrapper: {
          zIndex: theme.zIndex.appBar,
          position: "absolute",
          bottom: mixins.searchInputBuffer.height + 48,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: 0,
        },
        mainMenuContainer: {},
        footerActionContainer: {},
      },
    },
    DirectoryPage: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          gap: theme.spacing(1),
          margin: theme.spacing(0, -3),
          "& .subCategory-filterbar": {
            display: "none",
          },
          ":after": BOTTOM_GREDIENT_PAGE_EFFECT,
        },
        actionContainer: {
          flexDirection: "row",
          gap: theme.spacing(1.5),
          "& .all": {
            display: "none",
          },
        },
        toolbarContainer: {
          position: "relative",
          display: "flex",
          margin: theme.spacing(3, 6, 0),
          gap: theme.spacing(3),
        },
        searchBarContainer: {
          flex: "1 1 0",
          width: "auto",
          height: "auto",
          padding: theme.spacing(0),
        },
        filterSection: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          top: 0,
          zIndex: 1,
          paddingTop: theme.spacing(4),
          width: "100vw",
          "& .category-filterbar,& .subCategory-filterbar": {
            padding: theme.spacing(0),
            position: "relative",
            maxWidth: "100%",
            margin: "0 auto",
            "&:after": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
              zIndex: 1,
              position: "absolute",
              right: "2px",
              top: 0,
              bottom: 0,
            },
            "&:before": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
              zIndex: 1,
              position: "absolute",
              left: "-10px",
              top: 0,
              bottom: 0,
            },
          },
          "& .category-filterbar": {
            order: 0,
          },
          "& .subCategory-filterbar": {
            order: 1,
          },
        },
        categoryFilterBar: {
          gap: theme.spacing(2),
          padding: theme.spacing(0.25, 0),
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(6),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
          "& .allFilter-button": {
            textTransform: "uppercase",
          },
        },
        subCategoryFilterBar: {
          gap: theme.spacing(3),
          width: "100%",
          "& .MuiToggleButton-root.MuiToggleButtonGroup-grouped": {
            borderRadius: "9999px",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButton-root.MuiToggleButtonGroup-grouped:first-of-type":
            {
              marginLeft: 0,
            },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
        scrollPane: {
          padding: 0,
          "& .MuiDivider-root": {
            display: "none",
          },
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateRows: "repeat(2, 1fr)",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: theme.spacing(2.5),
          padding: theme.spacing(0.75, 3.75),
          overflowX: "hidden",
          overflowY: "auto",
          minHeight: "622px",
          height: "622px",
          width: "100%",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
        gridItem: {
          width: "178px",
        },
        emptyDataWrapper: {
          minHeight: "622px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        navigationWrapper: {
          zIndex: theme.zIndex.appBar,
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: 0,
        },
        venueSelector: {},
        mainMenuContainer: {},
        footerActionContainer: {},
      },
    },
    DirectorySkeletonCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "311px",
          borderRadius: "4px",
          backgroundColor: theme.palette.background.paper,
          boxShadow: "none",
        },
        avatar: {
          boxShadow: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "0",
          width: "100%",
          height: "178px",
          flex: "0 0 178px",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(2),
          height: "100%",
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
        venueLogo: {
          height: "26px",
          width: "86px",
        },
        primaryText: {
          fontSize: "1.25rem",
        },
        secondaryText: {
          fontSize: "1.25rem",
        },
      },
    },
    FooterAction: {
      styleOverrides: {
        root: {
          display: "flex",
          "& > *": {
            flex: "1 0 50%",
            height: "80px",
          },
        },
        footerActionButton: {
          fontSize: "1.25rem",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 0,
          borderBottom: "none",
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          "&:first-of-type": {
            borderLeft: "none",
          },
          "&:last-of-type": {
            borderRight: "none",
          },
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(2),
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
              "& .highlight": {
                fill: theme.palette.primary.main,
              },
            },
          },
          "&.Mui-disabled": {
            color: alpha(theme.palette.text.primary, 0.26),
            "& .MuiSvgIcon-root .highlight": {
              fill: alpha(theme.palette.primary.main, 0.26),
            },
          },
          "&:active,&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: alpha(theme.palette.primary.main, 0.8),
            "&:after": {
              content: "''",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              borderBottom: `5px solid ${theme.palette.primary.main}`,
            },
            "& .MuiSvgIcon-root  .highlight": {
              fill: theme.palette.primary.contrastText,
            },
          },
          "&.Mui-active": {
            color: theme.palette.primary.contrastText,
            backgroundColor: alpha(theme.palette.primary.main, 0.8),
            "&:after": {
              content: "''",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              borderBottom: `5px solid ${theme.palette.primary.main}`,
            },
            "& .MuiSvgIcon-root .highlight": {
              fill: theme.palette.primary.contrastText,
            },
          },
        },
      },
    },
    AppDetailPage: {
      styleOverrides: {
        root: {
          ":after": BOTTOM_GREDIENT_MAP_PAGE_EFFECT_1,
        },
        wrapper: {
          position: "absolute",
          bottom: 0,
          zIndex: 1300,
          alignItems: "baseline",
          gap: theme.spacing(2),
          left: 0,
          right: 0,
          borderRadius: "24px",
          margin: theme.spacing(0, 6, 6),
          display: "flex",
          flexDirection: "column",
        },
        container: {
          width: "100%",
          boxShadow: theme.shadows[15],
          height: 429,
          zIndex: theme.zIndex.modal,
          bottom: "25px",
          display: "flex",
          background: theme.palette.background.paper,
          borderRadius: `24px`,
          padding: 0,
          flexDirection: "column",
        },
        kioskBackButton: {
          display: "flex",
          padding: 0,
          borderRadius: "16px",
          width: "70px",
          height: "72px",
          "& .MuiSvgIcon-root": {
            width: "34px",
            height: "34px",
          },
        },
        primarySection: {
          display: "flex",
          flexDirection: "row",
          padding: theme.spacing(3, 5, 2, 5),
          height: "100%",
          justifyContent: "space-between",
        },
        secondarySection: {
          display: "flex",
          flexDirection: "row",
          padding: theme.spacing(2, 5),
          height: "104px",
          background: "#F6F6F6",
          alignItems: "center",
          borderRadius: "0 0 24px 24px",
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          padding: theme.spacing(2.5, 0),
          width: "511px",
        },
        avatarContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(3),
        },
        occupantLogo: {
          width: "64px",
          height: "64px",
          borderRadius: 0,
        },
        venueLogoContainer: {},
        venueLogoImage: {
          height: "32px",
        },
        detailContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        listInfoContainer: {
          textTransform: "uppercase",
        },
        listInforItem: {
          "&.category .MuiTypography-root": {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
            overflow: "hidden",
            maxWidth: "220px",
          },
          "& .highlight": {
            fill: theme.palette.primary.main,
          },
        },
        listInfoDivider: {},
        divider: {
          width: "120px",
          borderBottomWidth: "1px",
          borderColor: theme.palette.divider,
        },
        titleText: {
          fontWeight: 700,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
        },
        qrCodeContainer: {
          display: "flex",
          gap: theme.spacing(2),
          alignItems: "center",
        },
        qrCode: {
          borderRadius: "0.8px",
          padding: theme.spacing(0.5),
          marginTop: 0,
          boxShadow: "none",
          border: "0.5px solid #C7C6C6",
          width: "80px",
          "& .AppQRCode-content:last-child": {
            paddingBottom: 0,
          },
        },
        qrCodeHelperText: {
          width: "180px",
          textTransform: "uppercase",
        },
        actionContainer: {
          marginLeft: "auto",
        },
        actionButton: {},
        placeDetailTabContainer: {
          width: "350px",
          height: "100%",
        },
        placeDetailTabs: {
          padding: theme.spacing(1),
          "& .MuiTabs-scroller:after": {
            display: "inline-flex",
            content: "''",
            position: "absolute",
            bottom: 0,
            width: "100%",
            zIndex: -1,
            borderBottom: `2px solid #C7C6C6`,
          },
        },
        placeDetailTab: {
          padding: theme.spacing(1, 2),
          fontSize: "1rem",
          textTransform: "uppercase",
          minHeight: "24px",
          "&.tab-hidden": {
            position: "absolute",
            zIndex: -1,
            pointerEvents: "none",
            visibility: "hidden",
          },
        },
        placeDetailTabPanel: {
          paddingTop: theme.spacing(1),
        },
      },
    },
    AppQRCode: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.common.white,
        },
      },
    },
    InfoItem: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1),
          alignItems: "center",
        },
        iconContainer: {
          display: "flex",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
          },
        },
        labelContainer: {
          fontSize: "1.25rem",
        },
      },
    },
    PlaceDetailTabPanel: {
      styleOverrides: {
        root: {},
      },
    },
    PromotionList: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          paddingBottom: theme.spacing(2),
          gap: theme.spacing(2),
          overflow: "auto hidden",
          "&::-webkit-scrollbar": {
            width: "4px",
            height: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: theme.palette.grey[300],
          },
        },
        promotionListItem: {
          width: "105px",
          height: "198px",
          objectFit: "cover",
        },
      },
    },
    GalleryCarousel: {
      styleOverrides: {
        root: {
          margin: "0 auto",
          width: "100%",
        },
        galleryCarousel: {
          "& .splide__track": {
            padding: 0,
            margin: 0,
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(1.5),
            gap: theme.spacing(1),
          },
          "& .splide__pagination__page": {
            width: "8px",
            height: "8px",
            margin: 0,
            backgroundColor: "#C7C6C6",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "16px",
            borderRadius: "30px",
          },
        },
        galleryCarouselItem: {
          width: "100%",
          height: "198px",
          objectFit: "cover",
        },
      },
    },
    VuiDetailCard: {
      styleOverrides: {
        root: {
          height: "100%",
          display: "flex",
          flexDirection: "column",
          ":after": BOTTOM_GREDIENT_PAGE_EFFECT,
        },
        backButton: { padding: theme.spacing(5, 4.5) },
        backButtonWrapper: {
          marginLeft: theme.spacing(6),
          width: "fit-content",
        },
        contentWrapper: {
          position: "relative",
          height: "100%",
          padding: theme.spacing(7, 4),
        },
        card: {
          backgroundColor: "transparent",
          display: "flex",
          flexDirection: "row",
          justifyContent: "start",
          gap: theme.spacing(5),
          height: "531px",
          padding: 0,
          maxHeight: "40dvh",
        },
        coverBanner: {
          position: "absolute",
          height: "190px",
          top: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundColor: "#F6F6F6E5",
          backgroundBlendMode: "lighten",
        },
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
          width: "511px",
        },
        actionButton: {
          minWidth: 128,
          // TODO: Recheck whether this should be theme.palette.background.paper
          backgroundColor: theme.palette.common.white,
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
          "& .MuiSvgIcon-root": {
            marginRight: 0,
            width: 32,
            height: 32,
          },
        },
        actionContainer: {
          display: "none",
          flexDirection: "row",
          gap: theme.spacing(1.5),
        },
        toolbarContainer: {
          position: "relative",
          display: "flex",
          gap: theme.spacing(3),
        },
        searchBarContainer: {
          width: "100%",
          height: "auto",
          padding: theme.spacing(0, 6),
        },
        image: {
          maxWidth: "unset",
          margin: "0 auto",
          borderRadius: "10px",
          boxShadow: "0px 4px 20px 0px #0000000D",
          maxHeight: "unset",
          height: "unset",
          //TODO:: should we use fixed width and height?
          width: "100%",
        },
        infoListItem: {
          "& .MuiListItemText-root .MuiListItemText-primary": {
            fontSize: "1.25rem",
            color: theme.palette.text.primary,
            "& .MuiTypography-root": {
              fontSize: "1.25rem",
            },
          },
          "& .MuiAvatar-root": {
            width: "20px",
            height: "20px",
            background: "unset",
            borderRadius: 0,
            "& .MuiSvgIcon-root": {
              width: "auto",
              fontSize: "1.5rem",
              color: theme.palette.text.primary,
              "& .highlight": {
                fill: theme.palette.primary.main,
              },
            },
          },
          "& .MuiListItemAvatar-root": {
            minWidth: "unset",
            marginRight: theme.spacing(1),
          },
        },
        cardHeaderAction: {},
        cardHeaderActionButton: {},
        headerWrapper: { height: "7.5rem" },
        cardHeader: {
          lineHeight: 1.5,
          flex: "unset",
          color: theme.palette.text.primary,
          margin: theme.spacing(2, 0),
          marginBottom: theme.spacing(2),
          padding: 0,
          paddingBottom: 0,
          textAlign: "start",
          alignItems: "start",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          fontSize: "2rem",
          fontWeight: 700,
          "& .MuiCardHeader-action": {
            marginRight: 0,
          },
        },
        cardContent: {
          padding: 0,
          marginTop: 0,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          position: "relative",
          "&:last-child": {
            paddingBottom: 0,
          },
        },
        cardContentSecondaryText: {
          fontSize: "1rem",
          lineHeight: 1.5,
          color: theme.palette.grey[800],
          maxHeight: "unset",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 8,
          overflow: "hidden",
        },
        divider: {
          display: "block",
          width: "25%",
          margin: theme.spacing(3, 0),
          borderBottomWidth: "1px",
          borderColor: theme.palette.primary.main,
        },
        infoContainer: {
          display: "flex",
          gridGap: theme.spacing(5),
          padding: 0,
        },
        qrCode: {
          width: "133px",
          height: "133px",
          marginTop: 0,
          padding: theme.spacing(0.5),
          borderRadius: "4px",
          border: `none`,
          "& .MuiCardContent-root:last-child": {
            paddingBottom: 0,
          },
          boxShadow: "0px 4px 20px 0px #0000000D",
        },
        qrCodeContainer: {
          padding: 0,
          gap: theme.spacing(2.25),
          textAlign: "center",
          display: "flex",
          width: "auto",
          flexDirection: "column",
          alignItems: "center",
          position: "absolute",
          bottom: 0,
          right: 0,
          zIndex: 1,
        },
        qrcodePrimaryText: {
          fontWeight: 400,
          color: theme.palette.text.primary,
          textTransform: "uppercase",
          fontSize: "1rem",
        },
        qrCodeSecondaryText: {
          fontWeight: 400,
          color: theme.palette.text.primary,
          textTransform: "uppercase",
          fontSize: "1rem",
        },
        buttonContainer: {
          marginTop: "auto",
          gap: theme.spacing(3),
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
        },
        button: {
          flex: "0 0 188px",
          textTransform: "uppercase",
          fontSize: "1rem",
          fontWeight: 700,
        },
        pageWrapper: { flex: "1 1 0" },
        cardMediaWrapper: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: theme.spacing(3),
          width: "300px",
          maxHeight: "531px",
          aspectRatio: "9 / 16",
        },
        mainMenuContainer: {},
        footerActionContainer: {},
      },
    },
    AppDirectionOverview: {
      styleOverrides: {
        root: {
          ":after": BOTTOM_GREDIENT_MAP_PAGE_EFFECT_1,
        },
        actionButtonWrapper: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(2),
        },
        container: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          alignItems: "start",
          position: "absolute",
          top: "unset",
          right: 0,
          left: 0,
          bottom: 0,
          margin: theme.spacing(0, 6, 6, 6),
          minHeight: 320,
          zIndex: theme.zIndex.modal,
        },
        cardContainer: {
          gap: theme.spacing(4),
          padding: theme.spacing(4, 7),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          borderRadius: "24px",
          height: mixins.kioskDirectionCard.height,
          width: "100%",
        },
        cardBody: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        cardAction: {},
        headerWrapper: {
          display: "flex",
          justifyContent: "space-between",
        },
        locationContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
        primaryText: {
          fontWeight: 400,
          fontSize: "1.25rem",
          margin: 0,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          WebkitLineClamp: 1,
          overflow: "hidden",
          maxWidth: "300px",
        },
        secondaryText: {
          color: theme.palette.text.secondary,
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: "1rem",
        },
        stepCardContainer: {
          padding: theme.spacing(4, 7),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          borderRadius: "24px",
          height: mixins.kioskStepOverviewCard.height,
          width: "100%",
        },
        stepCardBody: {
          position: "relative",
          "button, a": { pointerEvents: "all" },
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "20px",
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
          },
        },
        stepper: {
          maxHeight: mixins.kioskStepOverviewContent.height,
          paddingBottom: theme.spacing(2.5), // Prevent overlapping from bottom gradient effect.
          overflowY: "auto",
          gap: theme.spacing(2),
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "& .MuiStep-vertical": {
            ":not(:last-of-type)": {
              "& .MuiStepLabel-labelContainer": {
                borderBottom: "none",
              },
            },
            "& .MuiStepLabel-labelContainer": {
              padding: 0,
            },
          },
        },
        originStep: {},
        destinationStep: {
          "& .MuiStepLabel-iconContainer": {
            "& .MuiBox-root": {
              borderColor: "#8E8C8D",
              "& .MuiAvatar-root": {
                backgroundColor: "#8E8C8D",
                border: "none",
              },
            },
          },
        },
        stepIconContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${theme.palette.primary.main}`,
          minWidth: "88px",
          height: "88px",
          borderRadius: "50%",
        },
        stepAvatar: {
          margin: 0,
          width: "62px",
          height: "62px",
          backgroundColor: theme.palette.primary.main,
          border: `0.5px solid ${theme.palette.primary.main}`,
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
        kioskBackButton: {
          display: "flex",
          padding: 0,
          borderRadius: "16px",
          width: "70px",
          height: "72px",
          "& .MuiSvgIcon-root": {
            width: "34px",
            height: "34px",
          },
        },
        durationText: {
          position: "absolute",
          bottom: 0,
          paddingBottom: theme.spacing(1),
          left: "50%",
          transform: "translateX(-50%)",
          display: "inline-block",
          minWidth: "128px",
          borderRadius: "9999px",
          padding: theme.spacing(0, 2),
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.text.primary,
          fontSize: "1.25rem",
          lineHeight: 1.5,
        },
        ordinalSelector: {
          position: "absolute",
          right: "0px",
          bottom: `calc(${mixins.kioskDirectionCard.height}px + 16px)`,
        },
      },
    },
    AppDirectionSearch: {
      styleOverrides: {
        paper: {
          borderRadius: "64px",
          padding: theme.spacing(2.5, 3),
          display: "flex",
          alignItems: "center",
        },
        formControlLabel: {
          fontSize: "20px",
          textTransform: "uppercase",
          margin: 0,
          "& .MuiFormControlLabel-label": {
            fontWeight: 500,
            marginLeft: theme.spacing(2),
          },
        },
      },
    },
    DirectionCardActions: {
      styleOverrides: {
        root: {
          gap: theme.spacing(3),
          height: "auto",
          padding: 0,
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "center",
          "&>:not(:first-of-type)": {
            marginLeft: 0,
          },
        },
        actionButton: {
          width: "168px",
          height: "56px",
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(1),
          },
        },
      },
    },
    DirectionStepItem: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(2),
          },
          "& .MuiStepLabel-labelContainer": {
            padding: 0,
          },
          ":not(:first-of-type, :last-of-type)": {
            padding: theme.spacing(1, 2.5, 1, 3),
          },
          "&:first-of-type": {
            paddingBottom: theme.spacing(2),
            marginBottom: theme.spacing(1),
            borderBottom: "0.5px solid #C7C6C6",
            "& .MuiStepLabel-iconContainer": {
              paddingLeft: 0,
              paddingRight: theme.spacing(3),
            },
            "& .MuiListItemText-primary": {
              fontWeight: 400,
              textTransform: "uppercase",
              color: theme.palette.text.secondary,
            },
            "& .MuiListItemText-secondary": {
              color: theme.palette.text.primary,
            },
            "& .MuiStepLabel-labelContainer": {
              padding: theme.spacing(1.75, 0),
            },
          },
          "&:last-of-type": {
            paddingTop: theme.spacing(2),
            marginTop: theme.spacing(1),
            borderTop: "0.5px solid #C7C6C6",
            "& .MuiListItemText-primary": {
              fontWeight: 400,
              textTransform: "uppercase",
              color: theme.palette.text.secondary,
            },
            "& .MuiListItemText-secondary": {
              color: theme.palette.text.primary,
            },
            "& .MuiStepLabel-iconContainer": {
              paddingLeft: 0,
              paddingRight: theme.spacing(3),
            },
            "& .MuiStepLabel-labelContainer": {
              padding: theme.spacing(1.75, 0),
            },
          },
          "& .MuiStepLabel-vertical": {
            padding: 0,
          },
        },
        listItem: {
          "& .MuiListItemText-primary": {
            whiteSpace: "normal",
            color: theme.palette.text.primary,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.subtitle2.fontWeight,
          },
          "& .MuiListItemText-secondary": {
            fontSize: "0.75rem",
          },
          "& .MuiListItemSecondaryAction-root": {
            marginLeft: "auto",
            position: "static",
            transform: "none",
            color: theme.palette.text.secondary,
            right: 0,
            "& .MuiSvgIcon-root": {
              width: "16px",
              height: "16px",
            },
            "& .MuiIconButton-root": {
              padding: 0,
            },
          },
        },
      },
    },
    DirectionStepIcon: {
      styleOverrides: {
        root: {
          display: "flex",
          width: "40px",
          height: "40px",
          padding: theme.spacing(0.85),
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "6px",
          backgroundColor: "#F6F6F6",
          fontSize: "1.25rem",
          fontWeight: 400,
          color: theme.palette.text.primary,
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        originIcon: {
          fill: theme.palette.primary.main,
          width: 37,
          height: 37,
        },
        destinationIcon: {
          fill: theme.palette.error.main,
          width: 28,
          height: 47,
        },
        highlightedText: {
          color: theme.palette.primary.main,
          textAlign: "inherit",
          fontWeight: "700",
          lineHeight: "inherit",
          fontSize: "inherit",
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        root: {
          pointEvent: "",
          ":after": BOTTOM_GREDIENT_MAP_PAGE_EFFECT_1,
          zIndex: 2,
        },
        container: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          alignItems: "start",
          position: "absolute",
          top: "unset",
          right: 0,
          left: 0,
          bottom: 0,
          margin: theme.spacing(0, 6, 6, 6),
          minHeight: 320,
          zIndex: theme.zIndex.modal,

          // !NOTE: Disable directory-v-standard.theme style
          width: "auto",
          boxShadow: "none",
          height: "unset",
          maxWidth: "unset",
          background: "none",
          borderRadius: 0,
          padding: 0,
          marginLeft: "inherit",
          marginRight: "inherit",
          [theme.breakpoints.up("sm")]: {
            maxWidth: "unset",
            margin: theme.spacing(0, 6, 6, 6),
          },
        },
        cardContainer: {
          gap: theme.spacing(3),
          padding: theme.spacing(5, 7),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          borderRadius: "24px",
          height: mixins.kioskStepCard.height,
          width: "100%",
        },
        cardBody: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
        },
        cardAction: {
          display: "flex",
          gap: theme.spacing(10),
          justifyContent: "center",
          alignItems: "center",
        },
        actionButtonGroupContainer: {
          display: "flex",
          gap: theme.spacing(3),
          justifyContent: "center",
          alignItems: "center",
        },
        actionButtonWrapper: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(2),
        },
        originIconContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${theme.palette.primary.main}`,
          minWidth: "88px",
          height: "88px",
          borderRadius: "50%",
        },
        destinationIconContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid #8E8C8D`,
          minWidth: "88px",
          height: "88px",
          borderRadius: "50%",
          "& .MuiAvatar-root": {
            backgroundColor: "#8E8C8D",
            border: "none",
          },
          "&.is-current-step": {
            border: `1px solid ${theme.palette.primary.main}`,
            "& .MuiAvatar-root": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        locationAvatar: {
          margin: 0,
          width: "62px",
          height: "62px",
          backgroundColor: theme.palette.primary.main,
          border: `0.5px solid ${theme.palette.primary.main}`,
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
        overviewProgressContainer: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          width: "100%",
          gap: theme.spacing(2),
        },
        stepProgressBar: {
          display: "block",
        },
        descriptionContainer: {
          position: "relative",
          minWidth: "450px",
          height: "68px",
          borderRadius: "9999px",
          padding: theme.spacing(2, 4),
          backgroundColor: "#F6F6F6",
          color: theme.palette.text.primary,
          ":after": {
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: "-23px",
            content: "''",
            display: "inline-block",
            borderLeft: "11.5px solid transparent",
            borderRight: "11.5px solid transparent",
            borderTop: "24px solid #F6F6F6",
          },
        },
        descriptionText: {
          textAlign: "center",
          fontSize: "1.5rem",
          display: "-webkit-box",
          lineHeight: 1.75,
          textOverflow: "ellipsis",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
          wordBreak: "break-word",
        },
        headerWrapper: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          top: "unset",
        },
        iconNavButton: {
          display: "flex",
          alignItems: "center",
          color: theme.palette.primary.main,
        },
        exitButton: {
          height: "56px",
          minWidth: "170px",

          // !NOTE: Disable directory-v-standard.theme style
          backgroundColor: "transparent",
          borderColor: theme.palette.error.light,
          color: theme.palette.text.error,
          fontWeight: 500,
          "& .MuiSvgIcon-root": {
            fill: `inherit`,
          },
          "&:hover": {
            backgroundColor: `inherit`,
          },
        },
        playerButton: {
          height: "56px",
          minWidth: "170px",
          "& .MuiButton-startIcon>*:nth-of-type(1)": {
            fontSize: "1.25rem",
          },
        },
      },
    },
    BorderLinearProgress: {
      styleOverrides: {
        root: {
          position: "relative",
          width: "100%",
          "&:after": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            content: "''",
            display: "block",
            height: 8,
            width: "100%",
            borderRadius: "9999px",
            backgroundColor: theme.palette.grey[300],
            right: 0,
          },
        },
        linearProgress: {
          height: 8,
          borderRadius: "9999px",
          zIndex: 1,
          ":after": {
            position: "absolute",
            zIndex: 5,
            top: "50%",
            transform: "translateY(-50%)",
            height: 8,
            content: "''",
            display: "block",
          },
          "&.MuiLinearProgress-colorPrimary": {
            backgroundColor: "transparent",
            "&.Mui-start": {
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":after": {
              height: 8,
              width: 8,
            },
            "&.Mui-complete": {
              ":before": {
                backgroundColor: theme.palette.primary.main,
              },
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":before": {
              height: 8,
              width: 8,
            },
          },
          "& .MuiLinearProgress-bar": {
            margin: "auto 0",
            height: 8,
            borderRadius: "9999px",
            backgroundColor: theme.palette.primary.main,
            boxShadow: "none",
          },
        },
      },
    },
    EventPage: {
      styleOverrides: {
        root: {
          height: `100%`,
          ":after": BOTTOM_GREDIENT_PAGE_EFFECT,
        },
        actionButton: {
          minWidth: 128,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
          "& .MuiSvgIcon-root": {
            marginRight: 0,
            width: 32,
            height: 32,
          },
        },
        actionContainer: {
          display: "none",
          flexDirection: "row",
          gap: theme.spacing(1.5),
        },
        toolbarContainer: {
          position: "relative",
          display: "flex",
          gap: theme.spacing(3),
        },
        searchBarContainer: {
          width: "100%",
          height: "auto",
          padding: theme.spacing(0, 6),
        },
        emptyDataWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          height: "680px", // Specifies the carousel height, inclusive of pagination
          position: "relative",
        },
        carouselContainer: {
          display: "flex",
          flexDirection: "column",
          height: "auto",
          position: "absolute",
          left: 0,
          right: 0,
          overflow: "hidden",
          gap: theme.spacing(3),
        },
        carousel: {
          "& .splide": {
            margin: "0 auto",
            marginTop: theme.spacing(4), // Avoid cropping the top slide during scaling
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(5),
          },
          "& .splide__pagination__page": {
            width: "8px",
            height: "8px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "16px",
            borderRadius: "16px",
          },
          "& .splide__track": {
            padding: 0,
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(0.8)",
              opacity: 0.4,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        eventGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          gap: 3,
          "& .MuiToggleButton-root": {
            width: "244px",
            height: "45px",
            fontSize: "1rem",
            color: theme.palette.text.primary,
          },
        },
        navigationWrapper: {
          zIndex: theme.zIndex.appBar,
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: theme.spacing(0, 6.25),
          gap: theme.spacing(3),
        },
        mainMenuContainer: {},
        footerActionContainer: {},
        toggleButtonGroup: {
          background: theme.palette.background.paper,
          boxShadow: "0px 4px 24px 0px #0000000D",
          padding: theme.spacing(1),
          borderRadius: "64px",
          width: "300px",
          "& .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButtonGroup-grouped:last-of-type": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButton-root": {
            borderRadius: "64px",
            height: "45px",
            fontSize: "1.25rem",
            fontWeight: 400,
            padding: theme.spacing(1, 2),
          },
        },
        toggleButton: {
          textTransform: "uppercase",
        },
        eventImage: {
          width: "360px",
          aspectRatio: "9 / 16",
          borderRadius: "8px",
          boxShadow: "0px 4px 20px 0px #0000000D",
        },
      },
    },
    StepProgressBar: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          overflowX: "scroll",
          padding: theme.spacing(1),
          marginTop: 0,
          scrollbarWidth: "none", // Hide the scrollbar for firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
          },
          "&-ms-overflow-style:": {
            display: "none", // Hide the scrollbar for IE
          },
        },
        stepper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
          "& .MuiStepLabel-iconContainer": {
            padding: 0,
          },
          "& .destinationStep": {
            display: "none",
          },
        },
        originIcon: {
          display: "none",
        },
        connector: {
          "& .MuiStepConnector-line": {
            height: 8,
            border: 0,
            minWidth: 36,
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
          },
          "&.Mui-active": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.Mui-completed": {
            "& .MuiStepConnector-line": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
      },
    },
    PromotionPage: {
      styleOverrides: {
        root: {
          height: `100%`,
          ":after": BOTTOM_GREDIENT_PAGE_EFFECT,
        },
        toolbarContainer: {
          position: "relative",
          display: "flex",
          gap: theme.spacing(3),
        },
        searchBarContainer: {
          width: "100%",
          height: "auto",
          padding: theme.spacing(3, 6, 0),
        },
        carouselContainer: {
          display: "flex",
          flexDirection: "column",
          height: "auto",
          position: "absolute",
          left: 0,
          right: 0,
          overflow: "hidden",
          gap: theme.spacing(3),
        },
        cardListContainer: {
          display: "none",
        },
        carousel: {
          "& .splide": {
            margin: "0 auto",
            marginTop: theme.spacing(4), // Avoid cropping the top slide during scaling
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(5),
          },
          "& .splide__pagination__page": {
            width: "8px",
            height: "8px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "16px",
            borderRadius: "16px",
          },
          "& .splide__track": {
            padding: 0,
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(0.8)",
              opacity: 0.4,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        emptyDataContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          height: "680px", // Specifies the carousel height, inclusive of pagination
          position: "relative",
        },
        navigationWrapper: {
          zIndex: theme.zIndex.appBar,
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: theme.spacing(0, 6.25),
          gap: theme.spacing(3),
        },
        mainMenuContainer: {},
        footerActionContainer: {},
        promotionImage: {
          width: "360px",
          aspectRatio: "9 / 16",
          borderRadius: "8px",
          boxShadow: "0px 4px 20px 0px #0000000D",
        },
        promotionGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          gap: 3,
          "& .MuiToggleButton-root": {
            width: "244px",
            height: "45px",
            fontSize: "1rem",
            color: theme.palette.text.primary,
          },
        },
        toggleButtonGroup: {
          background: theme.palette.background.paper,
          boxShadow: "0px 4px 24px 0px #0000000D",
          padding: theme.spacing(1),
          borderRadius: "64px",
          width: "300px",
          "& .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButtonGroup-grouped:last-of-type": {
            borderRadius: "64px",
            border: "none",
          },
          "& .MuiToggleButton-root": {
            borderRadius: "64px",
            height: "45px",
            fontSize: "1.25rem",
            fontWeight: 400,
            padding: theme.spacing(1, 2),
          },
        },
        toggleButton: {
          textTransform: "uppercase",
        },
      },
    },
    AppKioskNavigation: {
      styleOverrides: {
        root: {},
        menuButton: {
          borderRadius: "16px",
          display: "flex",
          flex: "0 0 150px",
          minWidth: "unset",
          maxWidth: "unset",
          padding: theme.spacing(2),
          "&:not(.Mui-selected)": {
            "& .MuiSvgIcon-root .highlight": {
              fill: theme.palette.primary.main,
            },
          },
          "&.Mui-selected": {
            "& .MuiNavigationLink-backside": {
              display: "flex",
            },
          },
          "& .MuiNavigationLink-backside": {
            alignItems: "center",
            justifyContent: "center",
            "& .MuiSvgIcon-root": {
              marginBottom: 0,
              width: "96px",
              height: "96px",
              opacity: 0.1,
            },
          },
        },
        navigationContainer: {
          maxWidth: "unset",
          marginBottom: 0,
          padding: theme.spacing(3, 6),
          height: "174px",
          borderRadius: "0px",
          gap: theme.spacing(2),
          boxShadow: "none",
        },
        searchBarContainer: {
          height: "auto",
          padding: theme.spacing(3, 6, 0),
        },
        actionContainer: {
          display: "none",
        },
        actionButton: {},
      },
    },
    VenueSelector: {
      styleOverrides: {
        root: {
          gap: theme.spacing(3),
        },
        buttonWrapper: {
          display: "flex",
          justifyContent: "center",
          transition: `background ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
          "&.siam-paragon": {
            order: 1,
          },
          "&.siam-center": {
            order: 2,
          },
          "&.siam-discovery": {
            order: 3,
          },
          "&.selected": {
            transform: "none",
            marginLeft: 0,
            marginRight: 0,
            "&.all .MuiButtonBase-root": {
              background: "#FF3A75",
            },
            "&.siam-paragon .MuiButtonBase-root": {
              background: "#A3873E",
            },
            "&.siam-center .MuiButtonBase-root": {
              background: "#000",
            },
            "&.siam-discovery .MuiButtonBase-root": {
              background: "#66676C",
            },
          },
        },
        icon: {
          borderRadius: 0,
          "& img": {
            transition: `filter ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
            objectFit: "contain",
          },
        },
        button: {
          width: "88px",
          height: "88px",
          background: `url(https://s3.venue.in.th/venue_btn_bg_20343fafe1.png)`,
          backgroundSize: "contain",
          backgroundColor: "unset",
          borderRadius: "8px",
          boxShadow: "0px 6px 8px 0px #0000001A",
          padding: theme.spacing(1),
          transition: `background ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
          "&.Mui-selected": {
            background: "none",
            ":hover": {
              backgroundColor: "unset",
            },
            "& img": {
              filter: "brightness(0) invert(1)",
            },
          },
        },
        currentVenueChip: {
          display: "none",
        },
      },
    },
    HomePage: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        fullscreenLayout: {
          backgroundColor: "transparent",
          position: "relative",
          flex: 1,
          zIndex: theme.zIndex.modal - 1,
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        welcomeContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
          height: "100%",
          zIndex: 2,
        },
        actionContainer: {
          marginTop: 0,
          display: "flex",
          justifyContent: "center",
          width: "100%",
        },
        actionButton: {
          background:
            "radial-gradient(50% 921.97% at 50% 50%, rgba(35, 31, 32, 0.5) 0%, rgba(35, 31, 32, 0) 100%)",
          borderRadius: "0",
          color: theme.palette.common.white,
          fontSize: "1.875rem",
          textTransform: "uppercase",
          width: "55%",
          "& .MuiSvgIcon-root": {
            fontSize: "2rem",
            marginRight: theme.spacing(2.5),
          },
        },
        banner: {
          height: "120px",
          width: "100%",
        },
        touchIconButton: {
          background:
            "linear-gradient(224.66deg, #1FC3F6 2.84%, #F22D6F 98.86%), linear-gradient(133.26deg, rgba(215, 215, 215, 0) 7.37%, rgba(124, 70, 155, 0.5) 101.21%)",
          padding: theme.spacing(3.25),
          position: "absolute",
          right: 140,
          top: 100,
          "&:after, :before": {
            opacity: 0,
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            height: "100%",
            width: "100%",
            border: `60px solid rgb(35,31,32,0.4)`,
            borderRadius: 9999,
            zIndex: -1,
          },
          "&:after": {
            animation: `ripple 2.5s infinite ${theme.transitions.easing.easeInOut}`,
          },
          "&:before": {
            animation: `ripple 2.5s infinite ${theme.transitions.easing.easeInOut} 0.5s`,
          },
          "& .MuiSvgIcon-root": {
            fontSize: "4rem",
            color: theme.palette.common.white,
            transform: "rotate(-30deg)",
          },
        },
      },
    },
    FeatureChipToggleBar: {
      styleOverrides: {
        root: {
          minWidth: "100%",
          justifyContent: "center",
          padding: theme.spacing(1),
        },
        button: {
          height: "48px",
          width: "48px",
          borderRadius: "9999px",
          backgroundColor: "#231F20B2",
          border: "1px solid #231F20B2",
          "&> .MuiSvgIcon-root": {
            width: "28px",
            height: "28px",
          },
          "&.Mui-selected": {
            background: theme.palette.primary.main,
            "& svg": {
              fill: "#231F20B2",
            },
            ":hover": {
              background: theme.palette.primary.main,
            },
          },
          "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: "50%",
          },
          "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            border: "1px solid #231F20B2",
            margin: 0,
            borderRadius: "50%",
          },
          "&.MuiToggleButtonGroup-grouped:first-of-type": {
            marginLeft: 0,
          },
          "& svg": {
            margin: 0,
            fill: theme.palette.common.white,
          },
          ":hover": {
            background: theme.palette.primary.main,
            "& svg": {
              fill: "#231F20B2",
            },
          },
        },
        text: {
          display: "none",
        },
      },
    },
    LanguageButton: {
      defaultProps: {
        MenuProps: {
          /**
           * [Anchor playground](https://mui.com/material-ui/react-popover/#anchor-playground)
           *  */
          transformOrigin: { horizontal: "center", vertical: "bottom" },
          anchorOrigin: { horizontal: "center", vertical: "top" },
        },
      },
      styleOverrides: {
        root: {
          gap: theme.spacing(2),
          padding: theme.spacing(3),
          "&:hover": {
            boxShadow: "none",
          },
        },
        menuPaper: {
          padding: theme.spacing(1),
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          marginTop: theme.spacing(-3),
          "& .MuiList-root": {
            display: "flex",
            gap: theme.spacing(2),
            padding: 0,
          },
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            marginLeft: -0.5,
            marginRight: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: "unset",
            left: "50%",
            bottom: "-23px",
            transform: "translateX(-50%)",
            width: 0,
            height: 0,
            backgroundColor: "transparent",
            borderLeft: "14px solid transparent",
            borderRight: "14px solid transparent",
            borderTop: `24px solid ${theme.palette.background.paper}`,
          },
        },
        menuItem: {
          padding: theme.spacing(1, 2),
          minWidth: "92px",
          borderRadius: "8px",
          justifyContent: "center",
          fontSize: "1.25rem",
          "& .MuiAvatar-root": {
            display: "none",
          },
          "&.active": {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
        },
        label: { display: "flex", fontSize: "1.25rem" },
        avatar: { width: "32px", height: "32px" },
      },
    },
    SearchPage: {
      styleOverrides: {
        root: {
          height: "100%",
          ":after": BOTTOM_GREDIENT_SEARCH_PAGE_EFFECT,
        },
        listContainer: {
          position: "relative",
          height: mixins.kioskSearchList.height,
          padding: theme.spacing(2, 0),
          ":after": BOTTOM_GREDIENT_SEARCH_RESULT_LIST_EFFECT,
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        toolbarContainer: {},
        categoryFilterBarContainer: {
          height: mixins.searchCategoryFilterBuffer.height,
          width: "100%",
          padding: theme.spacing(2, 0),
        },
        categoryFilterBar: {
          position: "relative",
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
            zIndex: 1,
            position: "absolute",
            left: "-10px",
            top: 0,
            bottom: 0,
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(6),
          },
        },
        scrollPane: {
          padding: 0,
        },
        categoryFilterButtonGroup: {
          gap: theme.spacing(2),
        },
        categoryFilterButton: {},
        backButton: { padding: theme.spacing(5, 4.5) },
        backButtonWrapper: {
          width: "fit-content",
        },
        searchBarContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(0, 6),
          gap: theme.spacing(3),
          width: "100%",
          position: "absolute",
          left: 0,
          right: 0,
          bottom:
            mixins.searchKeyboardBuffer.height +
            mixins.searchCategoryFilterBuffer.height,
        },
        venueFilterContainer: {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          bottom:
            mixins.searchKeyboardBuffer.height +
            mixins.searchCategoryFilterBuffer.height +
            mixins.searchInputBuffer.height,
          marginBottom: theme.spacing(4),
          "& .MuiListItemButton-root": {
            width: "64px",
            height: "64px",
          },
        },
        searchInput: {
          border: "1px solid #231F20",
          borderRadius: "72px",
          padding: theme.spacing(2, 5, 2, 2),
          fontSize: "1.875rem",
          backgroundColor: theme.palette.background.paper,
          "& .MuiInputAdornment-positionStart": {
            "& .MuiSvgIcon-root": {
              border: "1px solid #231F20",
              borderRadius: "9999px",
              fontSize: "1.5rem",
              padding: theme.spacing(2),
              width: "66px",
              minHeight: "66px",
              marginRight: theme.spacing(2),
              justifyContent: "center",
            },
          },
          "& .MuiInputAdornment-positionEnd": {
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "row",
          gridTemplateRows: "repeat(2, max-content)",
          gridTemplateColumns: "repeat(5, max-content)",
          gap: theme.spacing(2.5),
          padding: theme.spacing(0.5, 6.5, 18.75),
          overflowX: "hidden",
          overflowY: "auto",
          flex: 1,
          width: "100%",
          "::-webkit-scrollbar": {
            display: "none",
          },
        },
        gridItem: {
          width: "178px",
        },
        emptyDataWrapper: {
          minHeight: "622px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        emptyData: {
          textAlign: "center",
          width: "25%",
        },
        suggestedList: {
          gridColumn: "1 / -1",
        },
      },
    },
    VuiSearchKeyboard: {
      styleOverrides: {
        root: {
          margin: 0,
          borderRadius: 0,
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    VuiOnscreenKeyboard: {
      styleOverrides: {
        root: {
          // [Example] (https://hodgef.com/simple-keyboard/editor/?d=hodgef/react-simple-keyboard-demos/tree/uc-customization)
          // Add your custom style here
          "& .hg-theme-default": {
            fontFamily: "inherit",
          },
          "& .simple-keyboard": {
            maxWidth: "100%",
            minHeight: mixins.searchKeyboardBuffer.height,
            padding: theme.spacing(6.25, 18.75),
            borderRadius: 0,
            backgroundColor: theme.palette.grey[200],
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: "center",
            "&.hg-theme-default .hg-row": {
              marginBottom: theme.spacing(1),
              "&:last-child": {
                marginBottom: 0,
              },
              "& .hg-button:not(:last-child)": {
                marginRight: theme.spacing(2),
              },
            },
            "& .hg-button": {
              height: 55,
              backgroundColor: "#333333",
              color: theme.palette.common.white,
              fontSize: "32px",
              fontWeight: 700,
              borderRadius: "8px",
              borderBottom: "none",
              "&>span": {
                display: "flex",
                fontSize: "inherit",
              },
            },
            "& .hg-activeButton": {
              backgroundColor: theme.palette.grey[300],
              color: theme.palette.text.primary,
            },
            "& .hg-button-number,& .hg-button-symbol, & .hg-button-abc,& .hg-button-lang":
              {
                fontSize: "16px",
                flexGrow: 1,
              },
            "& .hg-button-lang, & .hg-button-number, & .hg-button-abc": {
              flexGrow: 0.5,
            },
            "& .hg-button-shift,& .hg-button-bksp": {
              fontSize: "20px",
            },
            "& .hg-button-shift": {
              fontSize: "20px",
              flexGrow: 2,
              flexShrink: 0,
            },
            "& .hg-button-enter": {
              flexGrow: 2,
            },
            "& .hg-button-space": {
              flexGrow: 8,
            },
            "& .hg-primary-button": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
            },
            "& .hg-secondary-button": {},
            "& .hg-small-button": {},
          },
        },
      },
    },
    VuiSearchToggleButton: {
      styleOverrides: {
        root: {
          border: "1px solid #231F20",
          borderRadius: "72px",
          padding: theme.spacing(1.5, 2),
        },
        label: {
          fontSize: "1.875rem",
          order: 1,
          marginLeft: theme.spacing(1.75),
        },
        searchIcon: {
          border: "1px solid #231F20",
          borderRadius: "9999px",
          fontSize: "1.5rem",
          marginRight: 0,
          padding: theme.spacing(2),
          width: "66px",
          height: "66px",
          order: 2,
        },
      },
    },
    AppCategoryFilterButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "12px 16px",
          justifyContent: "center",
          width: "max-content",
          "&.Mui-selected": {
            "& .MuiTypography-root": {},
          },
          "&:hover": {},
          "&.Mui-selected, &.Mui-selected:hover": {},
        },
        label: {
          fontSize: "1.25rem",
          lineHeight: 1.5,
        },
        icon: {
          display: "none",
        },
      },
    },
    EmptyData: {
      styleOverrides: {
        primaryText: {
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: "1.875rem",
        },
        root: {
          color: "#C7C6C6",
        },
        iconWrapper: {
          "& .MuiSvgIcon-root": {
            color: "#C7C6C6",
            height: "104px",
            width: "104px",
          },
          marginBottom: theme.spacing(2),
        },
      },
    },
    OrdinalSelectSplide: {
      styleOverrides: {
        listItemButton: {
          width: 48,
          height: 48,
          justifyContent: "center",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "6px",
          fontSize: "1.25rem",
          color: "#8E8C8D",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.background.paper,
            },
          },
        },
        root: {
          "& .splide__slide": {
            "&.is-visible": {
              "&> *": {
                opacity: 0.2,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-visible.is-prev:not(.is-dragging)": {
              "&> *": {
                opacity: 0.6,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-visible.is-next:not(.is-dragging)": {
              "&> *": {
                opacity: 0.6,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-dragging": {
              "&> *": {
                opacity: 1,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
          },
        },
      },
    },
    AppOrdinalSelector: {
      styleOverrides: {
        root: {
          gap: theme.spacing(3),
          display: "flex",
          padding: theme.spacing(1),
          flexDirection: "column",
          borderRadius: 0,
          backgroundColor: "transparent",
          boxShadow: "none",
          width: "auto",
        },
        listItemButton: {
          borderRadius: "6px",
          backgroundColor: theme.palette.background.paper,
          fontSize: "1.5rem",
          width: "48px",
          height: "48px",
        },
      },
    },
    AppImageModal: {
      styleOverrides: {
        imageWrapper: {
          //overwrite venue theme breakpoint
          [theme.breakpoints.up("sm")]: {
            width: "80vw",
            maxHeight: "50vh",
          },
        },
      },
    },
    VerticalDirectionImageDialog: {
      styleOverrides: {
        root: {
          height: mixins.pageLayout.height,
          overflow: "hidden",
          zIndex: 1,
          "& .MuiPaper-elevation": {
            height: 292,
            maxWidth: 690,
            width: 690,
            borderRadius: "16px",
          },
        },
        container: {
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(4),
          padding: theme.spacing(7, 4),
        },
        image: {
          height: 180,
          width: 180,
        },
        descriptionContainer: {
          display: "flex",
          flexDirection: "column",
        },
        highlightedText: {
          fontWeight: 700,
          fontSize: "1.5rem",
        },
        headerContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        primaryText: {
          fontSize: "2.375rem",
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        secondaryText: {
          fontSize: "1.5rem",
        },
        arrowIcon: {
          width: "32px",
          height: "32px",
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "4px",
          overflow: "hidden",
          "&:first-of-type": {
            borderRadius: "4px",
          },
          "&:last-of-type": {
            borderRadius: "4px",
          },
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
        accordionSummary: {
          height: "130px",
          padding: theme.spacing(2, 4),
          gap: theme.spacing(3),
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          ":after": {
            content: "''",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 0,
            background: `linear-gradient(89deg, ${alpha(
              theme.palette.background.paper,
              0.9
            )} 49.87%, ${alpha(theme.palette.background.paper, 0)} 92.75%)`,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: theme.palette.primary.main,
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
        },
        coverImage: {
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#ffffffcc",
          backgroundBlendMode: "lighten",
          backgroundSize: "cover",
          filter: "grayscale(100%)",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          width: "60%",
        },
        summaryContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(4),
          alignItems: "center",
          zIndex: 1,
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          fontSize: "1.25rem",
          fontWeight: 700,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 3,
          overflow: "hidden",
          wordBreak: "break-word",
        },
        serviceIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "64px",
          height: "64px",
          background: theme.palette.background.default,
        },
        serviceIcon: {
          color: theme.palette.primary.main,
          width: "40px",
          height: "40px",
        },
        infoContainer: {},
        accordionDetails: {
          padding: theme.spacing(1),
          backgroundColor: "#E8E8E8",
        },
        locationList: {
          padding: theme.spacing(0, 3),
          overflow: "hidden auto",
          maxHeight: "280px",
          "::-webkit-scrollbar": {
            width: "4px",
          },
          "::-webkit-scrollbar-track": {
            background: "#C7C6C6",
          },
          "::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
          },
        },
        locationListItem: {
          width: 416,
          padding: theme.spacing(2),
        },
        locationTitleText: {
          "& .MuiListItemText-primary": {
            fontSize: "1.25rem",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            WebkitLineClamp: 1,
            textOverflow: "ellipsis",
            maxWidth: "80%",
          },
        },
        locationNavigateButton: {
          color: theme.palette.primary.main,
          marginRight: theme.spacing(-3),
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
      },
    },
    AdSuggestList: {
      styleOverrides: {
        root: {
          position: "relative",
          height: "368px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: theme.spacing(1.5),
          zIndex: 0,
          maxWidth: "977px",
          ":after": BOTTOM_GREDIENT_SUGGESTED_BRAND_SECTION_EFFECT,
        },
        title: {
          color: theme.palette.primary.main,
          fontSize: "1.5rem",
          fontWeight: "700",
        },
        carousel: {
          "& .splide__track": {
            padding: theme.spacing(6.5),
            margin: theme.spacing(-6.5),
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(1.5),
          },
        },
        carouselItem: {},
        card: {
          width: "178px",
        },
      },
    },
  },
})
